<div class="form-field">
  @if (name) {
    <label class="label" [class.bold]="bold" [attr.for]="inputId">
      <span>{{name}}</span>
    </label>
  }
  <input
    [id]="inputId"
    [placeholder]="placeholder"
    [formControl]="filter"
    [matMenuTriggerFor]="selectMenu"
    (menuOpened)="onMenuOpen()"
    (menuClosed)="onMenuClose()"
    #selectInput
    type="text"
    class="form-control select-input"
    [class.menu-opened]="isMenuOpened"
    >
</div>

<mat-menu #selectMenu="matMenu">
  <mat-selection-list #selectionList [multiple]="false" hideSingleSelectionIndicator>
    @for (item of filteredItems; track item) {
      <mat-list-option [value]="item" [selected]="selection.isSelected(item)">
        {{ display(item) }}
      </mat-list-option>
    }
    @if (!filteredItems.length) {
      <mat-list-option [disabled]="true" [selected]="false">
        {{ emptyMessage }}
      </mat-list-option>
    }
  </mat-selection-list>
</mat-menu>
